/**
 * @generated SignedSource<<e4243f374dee81d880cd31e564934502>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type bookmarkHeaderFeaturesContent$data = {
  readonly entityId: string;
  readonly " $fragmentType": "bookmarkHeaderFeaturesContent";
};
export type bookmarkHeaderFeaturesContent$key = {
  readonly " $data"?: bookmarkHeaderFeaturesContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"bookmarkHeaderFeaturesContent">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "bookmarkHeaderFeaturesContent"
};

(node as any).hash = "5964e8aca835dca3d801c4756dc72ad5";

export default node;
